import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const CBTConsole = () => {
  const [results, setResults] = useState([]);
  const [subject, setSubject] = useState(null);
  const [liveTimes, setLiveTimes] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const { id, cbtId } = useParams();
  const token = localStorage.getItem("token");

  const axiosInstance = axios.create({
    baseURL: `/${id}/v3`,
    headers: { "Content-Type": "application/json" },
  });

  // Poll for latest results
  useEffect(() => {
    let mounted = true;

    const fetchResults = async () => {
      try {
        const response = await axiosInstance.post(
          "/take-cbt/get-result-list",
          { tokenid: cbtId },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data?.status === "success" && mounted) {
          const now = Math.floor(Date.now() / 1000);
          const newResults = response.data.results || [];
          const subject = response.data.subject || [];

          setResults(newResults);

          setSubject(subject);

          const updatedTimes = {};
          newResults.forEach((r) => {
            if (r.timer) {
              const expiry = parseInt(r.timer, 10);
              const secondsLeft = expiry - now;
              updatedTimes[r.stud_id] = secondsLeft > 0 ? secondsLeft : 0;
            }
          });

          setLiveTimes(updatedTimes);
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    };

    fetchResults();
    const intervalId = setInterval(fetchResults, 5000);

    return () => {
      mounted = false;
      clearInterval(intervalId);
    };
  }, [cbtId]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveTimes((prev) => {
        const updated = {};
        Object.entries(prev).forEach(([id, time]) => {
          updated[id] = time > 0 ? time - 1 : 0;
        });
        return updated;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (secs) => {
    const min = String(Math.floor(secs / 60)).padStart(2, "0");
    const sec = String(secs % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  // Filter logic for search
  const filteredResults = results.filter((result) => {
    const term = searchTerm.toLowerCase();
    return (
      result.fname?.toLowerCase().includes(term) ||
      result.stud_id?.toLowerCase().includes(term) ||
      result.stud_class?.toLowerCase().includes(term)
    );
  });

  const handleRestart = async (stud_id) => {
    
    try {
        const response = await axiosInstance.post(
        "/take-cbt/restart-student",
        {
            tokenid: cbtId,
            stud_id: stud_id,
        },
        { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data.status === "success") {
        toast.success("Student test restarted.", { /* toast config */ });
        } else {
        toast.error("Failed to restart student test.");
        }
    } catch (error) {
        console.error("Restart error:", error);
        alert("Error restarting student.");
    }
    };


  return (
    <div className="bg-back">
      <Header />
      <div className="">
        <div className="card bg-purple2 rounded-0 p-6 text-center shadow-none">
          <h1 className="text-3xl font-bold text-center text-purple2 mb-2 mt-12">
            CBT Console
          </h1>
          <p className="text-center text-dark">
            Manage your Computer Based Tests (CBT) efficiently.
          </p>
        </div>

        <div className="px-lg-8 mt-lg-n12">
          <div
            className="card shadow-none bg-white p-6 text-center mt-8"
            style={{ borderRadius: "18px" }}
          >
            <div className="row align-items-center mb-4">

            <div className="col-lg-7 mb-4 text-start">
              <h2 className="text-dark mb-0">
                {subject ? `Results for ${subject}` : "Results"}
              </h2>
            </div>

            <div className="col-lg-5 position-relative mb-4">
              <input
                className="form-control form-control-lg text-dark fs-4 rounded-pill ps-8"
                placeholder="Search students by name, class, or student ID"
                style={{ paddingLeft: "2.5rem" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <i
                className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-4 text-muted"
                style={{ fontSize: "1.5rem" }}
              ></i>
            </div>

            </div>

            <div className="table-responsive">
              <table
                className="table table-striped table-align-middle mb-0"
                style={{ fontSize: "1.05rem" }}
              >
                <thead>
                  <tr>
                    <th className="fw-medium text-dark">No.</th>
                    <th className="fw-medium text-dark">Name</th>
                    <th className="fw-medium text-dark">Student ID</th>
                    <th className="fw-medium text-dark">Class</th>
                    <th className="fw-medium text-dark">Time Left</th>
                    <th className="fw-medium text-dark">Score</th>
                    <th className="fw-medium text-dark">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredResults.map((result, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="text-dark">{result.fname}</td>
                      <td className="text-dark">{result.stud_id}</td>
                      <td className="text-dark">{result.stud_class}</td>
                      <td className="text-dark">
                        {liveTimes[result.stud_id] >= 0
                          ? formatTime(liveTimes[result.stud_id])
                          : "00:00"}
                      </td>
                      <td className="text-dark">{result.total_mark || "0"}</td>
                      <td>
                        <td>
                            <button
                                className="btn btn-sm btn-outline-dark rounded-pill"
                                onClick={() => handleRestart(result.stud_id)}
                            >
                                Restart
                            </button>
                        </td>
                      </td>
                    </tr>
                  ))}
                  {filteredResults.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center py-4 text-muted">
                        No matching students found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CBTConsole;
